import React, { useContext } from 'react'
import isEmpty from 'lodash/isEmpty'
import Box from '@material-ui/core/Box'

import { ActionablesContext } from '../../../../contexts/ActionablesContext'
import { CashflowEventsContext } from '../../context'
import { CardContent } from '../../../../components/layout/Card'
import { InfoSection } from '../../../../components/InfoSection'
import { EmptyEventsList, EventsList } from './EventsList'
import { Button } from '../../../../components/Button'

export const OverviewScreen = () => {
  const { state } = useContext(CashflowEventsContext)
  const { infoImageSrc } = state
  return (
    <CardContent className='cashflow-events cashflow-events__overview'>
      <div className='block lg:grid lg:grid-cols-2'>
        <CashflowEventsList />
        <OverviewInfoSection imgSrc={infoImageSrc} />
      </div>
    </CardContent>
  )
}

const CashflowEventsList = () => {
  const { state } = useContext(CashflowEventsContext)
  const { cashflowEvents } = state
  return (
    <section className='cashflow-events__list cashflow-events__card-list'>
      <AddEventCard />
      {cashflowEvents.length === 0
        ? <EmptyEventsList />
        : <EventsList />
      }
    </section>
  )
}

const OverviewInfoSection = ({ imgSrc }) =>
  <InfoSection>
    <h3>
      Don't just pay for it,<br />
      <strong>Invest for it.</strong>
    </h3>
    <img className='cashflow-dashboard-image' alt='cashflow-events' src={imgSrc} />
  </InfoSection>

const AddEventCard = () => {
  const {
    state: { cashflowEvents, onCreateNewScenario, scenario },
    actions: { addEvent }
  } = useContext(CashflowEventsContext)
  const { cashflowEventsReadOnly, frozen } = useContext(ActionablesContext)

  if (frozen) return null

  const actionCardText = getActionCardText(cashflowEventsReadOnly, cashflowEvents, scenario?.id)
  const onClickAction = (cashflowEventsReadOnly) ? null : addEvent
  return (
    <div
      className='ui-card cashflow-event-card cashflow-event-card--add' style={{ cursor: (!cashflowEventsReadOnly) && 'pointer' }} onClick={onClickAction}>
      <Box
        display='flex'
        flexDirection={cashflowEventsReadOnly ? 'column' : 'row'}
        justifyContent={cashflowEventsReadOnly ? 'center' : 'space-between'}
        alignItems='center'
        width='100%'
        className='gap-3'
      >
        <h2 className='text-base ms:text-lg'>{actionCardText}</h2>
        {cashflowEventsReadOnly &&
          <Button
            className='button text-xs ms:text-sm'
            primary onClick={() => onCreateNewScenario()} trackAs='Add cashflow event card: New scenario'
          >
            Create a new scenario
          </Button>
        }
        {(!cashflowEventsReadOnly) &&
          <div className='add-event-button'>+</div>
        }
      </Box>
    </div>
  )
}

const getActionCardText = (cashflowEventsReadOnly, cashflowEvents, scenarioId) => {
  if (cashflowEventsReadOnly) {
    const readOnlyText =
      isEmpty(cashflowEvents)
        ? 'You can add your first cashflow event in scenario planning'
        : 'You can add another cashflow event in scenario planning'
    return readOnlyText
  } else if (!scenarioId) {
    return 'Add a new joint cashflow event'
  } else {
    return 'Add a new cashflow event'
  }
}
